/*Below comment for Sonarlint*/
/*global removeStyle */

globalThis.setSelectedDrawerOption = globalThis.setSelectedDrawerOption || function () { };
globalThis.updateDrawerResultCount = globalThis.updateDrawerResultCount || function () { };
jQuery(function () {

    let hideinFocusParentsChildHidden = function () {
        if ($('.DynamicContentSection.inFocus').length === 0) {
            setTimeout(function () {
                $('.inFocusList  ').each(function () {
                    var $contentDynamic = $(this);

                    var $cards = $contentDynamic.find('.inFocusContent--SingleCard');
                    var allCardsHidden = true;
                    $cards.each(function () {
                        if ($(this).is(":visible")) {
                            allCardsHidden = false;
                            return allCardsHidden;  // Exit early if any card is visible
                        }
                    });
                });
            }, 100);
        }
    };
    hideinFocusParentsChildHidden();
    $('button.Tags__Button, button.tag_Menu_Button').click(function () {
        $(".inFocusList ").parents(".inFocus ").removeClass('d-none');
        const timeOutDuration = 200; // Adjust this duration as needed
        setTimeout(function () {
            hideinFocusParentsChildHidden();
        }, timeOutDuration);
    });


    // Function to show only the first three visible cards
    function showFirstThreeCards() {
        const allCards = document.querySelectorAll('.inFocusList.equal-card .inFocusContent--SingleCard');
        let shownCount = 0;
        const maxShowCount = 3;
        // Show only the first three visible cards (if fewer than 3, include 'All')
        allCards.forEach((card) => {
            if (card.classList.contains('visible')) {
                if (shownCount < maxShowCount) {
                    card.classList.remove('hidden');
                    card.style.display = 'flex';  // Ensure it's displayed
                    shownCount++;
                } else {
                    card.classList.add('hidden');
                    card.style.display = 'none'; // Hide the card completely
                }
            } else {
                card.classList.add('hidden');
                card.style.display = 'none'; // Hide if not visible
            }
        });
    }

    // Function to filter the cards based on the active filter
    globalThis.applyFilter = function applyFilter(filterId) {
        const allCards = document.querySelectorAll('.inFocusList.equal-card .inFocusContent--SingleCard');
        let visibleCount = 0;
        const maxvisibleCount = 3;

        // Apply filter and mark cards as visible or not based on the filter
        allCards.forEach(card => {
            if (filterId === 'all' || filterId === "All" || card.classList.contains(filterId)) {
                card.classList.add('visible');
                visibleCount++;
            } else {
                card.classList.remove('visible');
            }
        });

        // Show the 'All' card when fewer than 3 visible cards after applying the filter
        const commonCards = document.querySelectorAll('.inFocusList.equal-card .inFocusContent--SingleCard.All');

        if (filterId === 'all') {
            // Always show the 'All' card when 'all' filter is applied
            commonCards.forEach(commonCard => {
                commonCard.classList.add('visible');
                commonCard.style.display = 'flex'; // Ensure the 'All' card is shown
            });
        } else {
            allCards.forEach(card => {
                if (filterId === 'all' || filterId === "All" || card.classList.contains(filterId)) {
                    card.classList.add('visible');
                    visibleCount++;
                } else {
                    card.classList.remove('visible');
                }
            });

            //setInlineDisplayBlock();
            // If fewer than 3 visible cards, show the 'All' card to complete the first 3 visible cards
            if (visibleCount < maxvisibleCount) {
                commonCards.forEach(commonCard => {
                    commonCard.classList.add('visible');
                    commonCard.style.display = 'flex'; // Ensure the 'All' card is shown
                    visibleCount++; // Increment the visible count to include 'All'
                });
            } else {
                // Hide 'All' card if there are enough visible cards
                commonCards.forEach(commonCard => {
                    commonCard.classList.remove('visible');
                    commonCard.style.display = 'none'; // Hide the 'All' card
                });
            }
        }

        // After filtering, show only the first three visible cards (including 'All' card if needed)
        showFirstThreeCards();
    }

    // Load the filter from localStorage on page load
    const savedFilter = localStorage.getItem('activeFilter') || 'all'; // Default to 'all' if no filter is saved
    globalThis.applyFilter(savedFilter); // Apply the saved filter on page load

    // Event listener for filter button clicks
    document.querySelectorAll('.tag_Menu_Button, .Tags__Button').forEach(button => {
        button.addEventListener('click', function () {
            const filterId = this.id;

            // Save the selected filter in localStorage
            localStorage.setItem('activeFilter', filterId);

            // Apply the selected filter
            globalThis.applyFilter(filterId);

            //for new target filtering for collection pages
            globalThis.setSelectedDrawerOption(filterId);
            globalThis.updateDrawerResultCount();
        });
    });

    jQuery(function ($) {
        //add here if any new tag option is added dynamically
        const filterClasses = ['Pharmacy', 'HealthCareProfessionals', 'NursingHome'];
        function setupFilterSync(filter1, filter2) {
            $(filter1 + ' .tag_Menu_Button, ' + filter2 + ' .Tags__Button').on('click', function () {
                var buttonId = $(this).attr("id");
                hideEmptyMenuTagFilter();
                //save local storage value selectedCount for sample order page checkbox value
                const selectedCount = localStorage.getItem("selectedCount");
                localStorage.clear();

                // If selectedCount was present, restore it
                if (selectedCount !== null) {
                    localStorage.setItem("selectedCount", selectedCount);
                }
                localStorage.setItem("activeFilter", buttonId);
                globalThis.filterContent(buttonId);
                globalThis.synchronizeActiveState(filter1, filter2, buttonId);

                //for new target filtering for collection pages
                globalThis.setSelectedDrawerOption(buttonId);
                globalThis.updateDrawerResultCount();
            });
        }
        globalThis.synchronizeActiveState = function synchronizeActiveState(filter1, filter2, activeId) {
            $(filter1 + ' .tag_Menu_Button').removeClass("activeTagFiter").attr("aria-disabled", "false");
            $(filter2 + ' .Tags__Button').removeClass("activeTagFiter").attr("aria-disabled", "false");

            $(filter1 + ' .tag_Menu_Button#' + activeId).addClass("activeTagFiter").attr("aria-disabled", "true");
            $(filter2 + ' .Tags__Button#' + activeId).addClass("activeTagFiter").attr("aria-disabled", "true");
        }

        globalThis.filterContent = function filterContent(activeId) {

            $('.Pharmacy, .HealthCareProfessionals, .NursingHome').hide();

            if (activeId === 'all' || activeId === 'All') {

                document.querySelectorAll('.load-section').forEach(el => el.classList.remove('d-none'));

                filerdHideLoader();
                $('.Pharmacy, .HealthCareProfessionals, .NursingHome, .All').show();
                $('.hideNonSelectedFilter').removeClass('hideNonSelectedFilter');
                const loadSection = document.querySelector('.load-section');

                //if load section is there then only load more functionality should
                if (loadSection) {
                    loadMoreFunctions();
                }
                // loadMoreFunctions();
            } else {
                //currentIndex = 0;
                //hide the load section for manual conetent card only when event page is not there
                if (!document.querySelector('.event-item')) {
                    document.querySelectorAll('.load-section').forEach(el => el.classList.add('d-none'));
                }
                $('.megaMenuInnerLink, .megaMenu_title, .dropdown__link').each(function () {
                    var $element = $(this);
                    var parent = $element.parents('.megaMenuDropdown, li');
                    var hasFilterClass = filterClasses.some(function (filterClass) {
                        return $element.hasClass(filterClass);
                    });
                    if (hasFilterClass) {
                        parent.addClass('hideNonSelectedFilter');
                        if ($element.hasClass(activeId)) {
                            filerdHideLoader();
                            $element.show();
                            parent.removeClass('hideNonSelectedFilter');
                        }
                    }
                });

                $('.' + activeId).show();
            }
            filerdHideLoader();
            hideEmptyMenuTagFilter();
        }

        setupFilterSync('.filter1', '.filter2');
        var savedFilter = localStorage.getItem("activeFilter") || 'all';
        globalThis.synchronizeActiveState('.filter1', '.filter2', savedFilter);
        globalThis.filterContent(savedFilter);
    });

    jQuery(function ($) {

        hideEmptyMenuTagFilter();
    })
    //hide main menu if tag filter group is not present
    let hideEmptyMenuTagFilter = function () {
        $('.megaMenuFirstSection').each(function () {
            var $this = $(this);
            var $megaMenuDropdown = $this.find('.megaMenuDropdown');
            $megaMenuDropdown.each(function () {
                if ($(this).find('li').filter('.hideNonSelectedFilter').length === $(this).find('li').length) {
                    $(this).find('li').parents('.content').parents('.megaMenuDropdown').addClass('hideNonSelectedFilter');
                } else {
                    $(this).find('li').parents('.content').parents('.megaMenuDropdown').removeClass('hideNonSelectedFilter');
                }
                // });
            })
            if ($megaMenuDropdown.length === 0) {
                return;
            }
            if ($megaMenuDropdown.filter('.hideNonSelectedFilter').length === $megaMenuDropdown.length) {
                $this.parents('.nav .dropdown__item').addClass('hideNonSelectedFilter');
                if ($this.parents('.dropdown__item').hasClass('show-dropdown')) {
                    removeStyle();

                }
            } else {
                $this.parents('.nav .dropdown__item').removeClass('hideNonSelectedFilter');
            }
        });
    }


    //nitin code for load more for manual content cards
    let eventItems = [];
    let loadMoreBtn, loadLessBtn, itemsPerLoadEl;
    let progressBar, infoText, remainingSpan, infoTextTemplate;

    itemsPerLoadEl = document.getElementById("hdnNumberOfItems");
    let itemsPerLoad = itemsPerLoadEl ? parseInt(itemsPerLoadEl.value, 10) : 0;

    let totalItems = 0;
    let currentIndex = 0;

    //Update UI and transfer focus to first newly shown card
    function updateUI(event) {
        const startIndex = currentIndex;
        const endIndex = Math.min(currentIndex + itemsPerLoad, totalItems);

        // Show the next batch
        for (let i = startIndex; i < endIndex; i++) {
            eventItems[i].style.display = 'block';
        }

        // Track the last visible card before updating currentIndex
        const previousLastIndex = currentIndex - 1;

        currentIndex = endIndex;

        // Move focus to the element after the last visible card before loading more, if any
        if (previousLastIndex >= 0 && eventItems[previousLastIndex]) {
            const sibling = eventItems[previousLastIndex].nextElementSibling;
            if (sibling) {
                const nextAnchor = sibling.matches("a")
                    ? sibling
                    : sibling.querySelector("a");

                if (nextAnchor) {
                    // only if it’s a real link/button in tab order
                    nextAnchor.focus({ preventScroll: false });
                }
            }
        }

        //Prevent Enter key from acting on the focused card
        if (event && event.type === 'keydown' && event.key === 'Enter') {
            event.preventDefault(); // Stop form submission or anchor behavior
            event.stopPropagation(); // Stop bubbling to newly focused element
        }

        // Update progress
        if (progressBar) {
            const percentage = (currentIndex / totalItems) * 100;
            progressBar.style.width = `${Math.min(percentage, 100)}%`;
        }

        // Info text
        if (infoText) {
            const shown = Math.min(currentIndex, totalItems);
            //infoText.textContent = `Showing ${shown} of ${totalItems}`;
            let infoTextContent = infoTextTemplate;
            infoText.textContent = infoTextContent
                .replace("{0}", shown)
                .replace("{1}", totalItems);
        }

        // Remaining text
        if (remainingSpan) {
            const remaining = totalItems - Math.min(currentIndex, totalItems);
            remainingSpan.textContent = remaining;
        }

        // Hide load more if done
        if (currentIndex >= totalItems) {
            loadMoreBtn.style.display = 'none';
        }
    }

    // Initial state
    function resetUI() {
        eventItems.forEach(item => (item.style.display = 'none'));
        currentIndex = 0;

        if (progressBar) progressBar.style.width = '0%';
        if (infoText) {
            let infoTextContent = infoTextTemplate;
            infoText.textContent = infoTextContent
                .replace("{0}", "0")
                .replace("{1}", totalItems);
        }
        if (remainingSpan) remainingSpan.textContent = totalItems;

        if (loadMoreBtn) {
            loadMoreBtn.style.display = 'inline-block';
        }

        updateUI(); // Show initial cards
    }

    // Setup DOM elements and bind events
    function initBatchCards() {
        eventItems = document.querySelectorAll('.inContentManual--SingleCard');
        loadMoreBtn = document.getElementById('load-more');
        loadLessBtn = document.getElementById('load-less');
        progressBar = document.getElementById('progress-bar');
        infoText = document.getElementById('info-text');
        infoTextTemplate = infoText.innerHTML;
        //remainingSpan = document.getElementById('eventLoadMore');

        if (!eventItems || eventItems.length === 0 || !loadMoreBtn) {
            return;
        }

        totalItems = eventItems.length;

        resetUI();

        //Remove old listeners and add fresh ones
        loadMoreBtn.removeEventListener('click', updateUI);
        loadMoreBtn.removeEventListener('keydown', handleLoadMoreKeyDown);

        loadMoreBtn.addEventListener('click', updateUI);
        loadMoreBtn.addEventListener('keydown', handleLoadMoreKeyDown);
    }

    // Intercept Enter key on "Load More" button
    function handleLoadMoreKeyDown(e) {
        if (e.key === 'Enter') {
            updateUI(e);
        }
    }

    // Clear display for already-shown cards
    function resetInlineDisplay() {
        let cards = document.querySelectorAll('.inContentManual--SingleCard');
        cards.forEach(card => {
            if (card.style.display === 'block') {
                card.style.removeProperty('display');
            }
        });
        cards = null;
    }

    // Reset cards and reload batch logic
    function loadMoreFunctions() {
        resetInlineDisplay();
        initBatchCards();
    }

    // Hide all cards with class "All"
    function setInlineDisplayBlock() {
        let cards = document.querySelectorAll('.inContentManual--SingleCard');
        cards.forEach(card => {
            if (card.classList.contains('All')) {
                card.style.display = 'none';
            }
        });
        cards = null;
    }

});

function filerdShowLoader() {


    //setLoaderHeight();
    const loaders = document.querySelectorAll("#filerdLoader, .filerdLoader");


    loaders.forEach(loader => {
        loader.style.setProperty("display", "flex");
    });

}
function filerdHideLoader() {
    const loaders = document.querySelectorAll("#filerdLoader, .filerdLoader");

    setTimeout(() => {
        loaders.forEach(loader => {
            loader.style.display = "none";
        });
    }, 500); // Hide after 1.5 seconds
}
function setLoaderHeight() {

    setTimeout(() => {
        const height = document.querySelector('.megaMenuFirstSection').offsetHeight;
        document.querySelector('.filerd-loader-overlay').style.height = height + 'px';
    }, 100);
}

//new target filtering for collection pages.

document.addEventListener('DOMContentLoaded', function () {
    const filterByButton = document.querySelector('[data-target-filter-open]');
    const filterDrawer = document.querySelector('[data-target-filter-drawer]');
    const filterCloseButton = document.querySelector('.targetFilter__panelClose');
    const drawerOptions = document.querySelectorAll('[data-target-filter-option]');
    const resultButton = document.querySelector('[data-target-filter-apply]');
    const resetButton = document.querySelector('[data-target-filter-reset]');

    // const drawerPanel = document.querySelector('.targetFilter__panel');
    //const focusableSelector = 'button';


    if (!filterByButton || !filterDrawer || !filterCloseButton
        || !drawerOptions.length || !resultButton || !resetButton) {
        return;
    }

    let filterBeforeDrawerOpen = localStorage.getItem('activeFilter') || 'all';

    globalThis.setSelectedDrawerOption = function setSelectedDrawerOption(activeFilter) {
        drawerOptions.forEach(function (option) {
            const optionFilter = option.dataset.filterValue;
            const isSelected = optionFilter === activeFilter && activeFilter !== 'all';

            option.classList.toggle('is-selected', isSelected);
            option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        updateResultButtonState();
    };

    function closeDrawer() {
        filterDrawer.hidden = true;
        filterDrawer.classList.remove('is-open');
        filterByButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('targetFilterDrawerOpen');
        document.body.classList.remove('targetFilterDrawerOpen');

    }
    function updateResultButtonState() {
        const selectedOption = document.querySelector(
            '[data-target-filter-option].is-selected'
        );

        const hasSelection = selectedOption !== null;
        const hasNonDefaultSelection = hasSelection &&
           selectedOption.dataset.filterValue !== 'all';

        resultButton.disabled = !hasSelection;
        resultButton.classList.toggle('is-disabled', !hasSelection);
        resultButton.setAttribute(
            'aria-disabled',
            hasSelection ? 'false' : 'true'
        );

        resetButton.disabled = !hasNonDefaultSelection;
        resetButton.classList.toggle('is-disabled', !hasNonDefaultSelection);
        resetButton.setAttribute(
            'aria-disabled',
            hasNonDefaultSelection ? 'false' : 'true'
        );

        if (resultButton.disabled) {
            resultButton.innerHTML = '<span>Results</span>';
        }
    }

    function restoreFilterBeforeDrawerOpen() {
        const filterId = filterBeforeDrawerOpen || 'all';

        localStorage.setItem('activeFilter', filterId);
        globalThis.applyFilter(filterId);
        globalThis.synchronizeActiveState('.filter1', '.filter2', filterId);
        globalThis.filterContent(filterId);
        globalThis.setSelectedDrawerOption(filterId);
        globalThis.updateDrawerResultCount();
    }
    globalThis.updateDrawerResultCount = function updateDrawerResultCount() {
        if (localStorage.getItem('activeFilter').toString().toLowerCase() === "all") return;
        // 1. Select all potential cards regardless of visibility
        const allCards = document.querySelectorAll(
            '.inFocusList.equal-card .inFocusContent--SingleCard, ' +
            '.inFocusList.equal-card .inContentManual--SingleCard'
        );

        // 2. Filter out elements where display is actually 'none' in the browser
        const visibleCards = Array.from(allCards).filter(card => card.offsetParent !== null);
        const totalVisibleCards = visibleCards.length;
        resultButton.innerHTML = '<span>Results (' + totalVisibleCards + ')</span>';
    }

    filterByButton.addEventListener('click', function () {
        filterBeforeDrawerOpen = localStorage.getItem('activeFilter') || 'all';
        globalThis.setSelectedDrawerOption(filterBeforeDrawerOpen);

        filterDrawer.hidden = false;
        filterDrawer.classList.add('is-open');
        filterByButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('targetFilterDrawerOpen');
        document.body.classList.add('targetFilterDrawerOpen');
    });

    filterCloseButton.addEventListener('click', function () {
        restoreFilterBeforeDrawerOpen();
        closeDrawer();
    });
    resultButton.addEventListener('click', closeDrawer);

    resetButton.addEventListener('click', function () {
        localStorage.setItem('activeFilter', 'all');
        globalThis.applyFilter('all');
        globalThis.synchronizeActiveState('.filter1', '.filter2', 'all');
        globalThis.filterContent('all');
        globalThis.setSelectedDrawerOption('all');
        globalThis.updateDrawerResultCount();
    });

    drawerOptions.forEach(function (option) {
        option.addEventListener('click', function () {
            const selectedFilter = option.dataset.filterValue;

            drawerOptions.forEach(function (btn) {
                btn.classList.remove('is-selected');
                btn.setAttribute('aria-pressed', 'false');
            });

            option.classList.add('is-selected');
            option.setAttribute('aria-pressed', 'true');

            updateResultButtonState();
            localStorage.setItem('activeFilter', selectedFilter);
            globalThis.applyFilter(selectedFilter);
            globalThis.synchronizeActiveState('.filter1', '.filter2', selectedFilter);
            globalThis.filterContent(selectedFilter);
            globalThis.updateDrawerResultCount();
        });
    });

    const savedFilter = localStorage.getItem('activeFilter') || 'all';
    globalThis.setSelectedDrawerOption(savedFilter);
    globalThis.updateDrawerResultCount();
    updateResultButtonState();

});